import { } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof CarouselCompanyCodeSetupService.props>

export default class CarouselCompanyCodeSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	goToCompanies () {
		this.router.push({
			name: 'OrganizationCompany',
			query: { tour: 'true' },
		});
	}
}
